/**
 * @component {"type":"FlipCards","version":"1.1"}
 */

define('component-flip-cards',['knockout', 'helpers', 'training', 'user-answers'], function(ko, helpers, Training, UserAnswers) {
    return function(parentVM, dataContext) {
        var self = this,
            entityVM = parentVM.entity,
            trainingVM = parentVM.training,
            training = new Training(),
            userAnswers = new UserAnswers();

        self.total = ko.observable(0);
        self.columnsCSS = ko.observable('');

        self.items = ko.computed(function() {
            var ID = entityVM.ID(),
                entity = training.getContent(ID),
                content = helpers.component.getContent(entity.componentsJSON, 'FlipCards'),
                arr = helpers.component.parseProp(content, 'items', 'FlipCardItem');

            self.total(arr.length);
            self.columnsCSS('flip-cards-' + content.columns);

            if (!arr.length) {
                return arr;
            }

            var interacted = (userAnswers.isPageVisited(ID)) ? true : !content.interaction;

            for (var i = 0; i < arr.length; i++) {
                arr[i].interacted = interacted.toString();
                arr[i].frontImage = "'" + trainingVM.parseMediaURL(arr[i].frontImage) + "'";
                arr[i].backImage = "'" + trainingVM.parseMediaURL(arr[i].backImage) + "'";
            }

            if (dataContext.debugMode) {
                console.log('flip cards items:');
                console.dir(arr);
            }

            return arr;
        });

        self.flip = function(obj, e) {
            var target = e.currentTarget;

            if (!target) {
                return;
            }

            target.removeAttribute('data-interacted');
            target.classList.toggle('flip-card-flipped');

            // if (!Modernizr.csstransitions) {
            //     require(['gsap'], function() {
            //         var tl = new window.TimelineMax(),
            //             f = target.querySelector('.flip-card-front'),
            //             b = target.querySelector('.flip-card-back');

            //         tl.to(f, self.duration(), {scaleX:0.0});
            //         tl.to(b, self.duration(), {scaleX:1.0}, '+=' + self.duration()/2);
            //     });
            // }

            trainingVM.updateVisited();
        };

    };

});

